import { render, staticRenderFns } from "./AddNewOrder.vue?vue&type=template&id=070d4527&scoped=true&"
import script from "./AddNewOrder.vue?vue&type=script&lang=ts&"
export * from "./AddNewOrder.vue?vue&type=script&lang=ts&"
import style0 from "./AddNewOrder.vue?vue&type=style&index=0&id=070d4527&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../boss_taobao/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070d4527",
  null
  
)

export default component.exports